import React from 'react';
import { Modal, Button } from 'antd';

interface ConfirmationModalProps {
  visible: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  isDanger?: boolean;
  confirmLoading?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  visible,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  isDanger = false,
  confirmLoading = false
}) => {
  return (
    <Modal
      visible={visible}
      footer={null}
      centered
      onCancel={onCancel}
      maskClosable={false}
      className='admin-modal-body'
    >
      <div>
        <p className='admin-modal-title'>{title}</p>
        <p className='admin-modal-text'>{message}</p>
        <div className='admin-modal-btn-container'>
          <Button className='btn btn-bordered' onClick={onCancel}>
            {cancelText}
          </Button>
          <Button
            className={`btn ${isDanger ? 'btn--danger' : 'btn--primary'}`}
            onClick={onConfirm}
            danger={isDanger}
            loading={confirmLoading}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
